import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { toast } from 'react-toastify';
import axios from "axios";
const baseUrl = process.env.REACT_APP_API;


const Header = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSticky, setSticky] = useState(false);
  const [username, setUsername] = useState(null);
  const [email, setEmail] = useState(null);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [profileForm, setProfileForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    walletAddress: ''
  });
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const navigate = useNavigate();

  // SVG Icons
const UserIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

const EditIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
  </svg>
);

const KeyIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>
  </svg>
);

const LogoutIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
    <polyline points="16 17 21 12 16 7"></polyline>
    <line x1="21" y1="12" x2="9" y2="12"></line>
  </svg>
);

const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

const MenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="3" y1="12" x2="21" y2="12"></line>
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <line x1="3" y1="18" x2="21" y2="18"></line>
  </svg>
);



  // useEffect(() => {
  //   const token = sessionStorage.getItem("authToken");

  //   if (token) {
  //     try {
  //       const decoded = jwtDecode(token);
  //       setUsername(decoded.firstName || "User");
  //       setEmail(decoded.email || "");
  //       setProfileForm({
  //         firstName: decoded.firstName || '',
  //         lastName: decoded.lastName || '',
  //         email: decoded.email || ''
  //       });
  //     } catch (error) {
  //       console.error("Invalid token", error);
  //     }
  //   }
  // }, []);

    // Fetch member data from the API
    useEffect(() => {
      const token = sessionStorage.getItem("authToken");
  
      if (token) {
        try {
          const decoded = jwtDecode(token);
          setUsername(decoded.firstName || "User");
          setEmail(decoded.email || "");
          const memberCode = decoded.memberCode
          
          // Fetch member details from the API using axios
          axios.get(`${baseUrl}/auth/member/${memberCode}`)
            .then(response => {
              const memberData = response.data;
              setProfileForm({
                firstName: memberData.firstName || '',
                lastName: memberData.lastName || '',
                email: memberData.email || '',
                walletAddress: memberData.walletAddress || ''
              });
            })
            .catch(error => {
              console.error("Error fetching member data", error);
              toast.error('Error fetching member data!');
            });
        } catch (error) {
          console.error("Invalid token", error);
        }
      }
    }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("authToken");
    toast.success("Logged out successfully!");
    navigate("/token/signin");
  };

  const handleProfileEdit = () => {
    setShowProfileModal(true);
    setDropdownOpen(false);
  };

  const handlePasswordChange = () => {
    setShowPasswordModal(true);
    setDropdownOpen(false);
  };

  const handleProfileSubmit = (e) => {
    e.preventDefault();
    const token = sessionStorage.getItem("authToken");
    const decoded = jwtDecode(token);
    const memberCode = decoded.memberCode
  
    const profileData = {
      memberCode: memberCode,  
      firstName: profileForm.firstName,
      lastName: profileForm.lastName,  
    };
  
    axios
      .put(`${baseUrl}/auth/profile`, profileData, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        // Success handling
        toast.success('Profile updated successfully!');
        setUsername(profileForm.firstName);  // Update the username as before
        setShowProfileModal(false);  // Close the modal
      })
      .catch((error) => {
        // Error handling
        console.error('There was an error updating the profile!', error);
        toast.error('Failed to update profile. Please try again.');
      });
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
  
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      toast.error('New passwords do not match!');
      return;
    }
    const token = sessionStorage.getItem("authToken");
    const decoded = jwtDecode(token);
    const memberCode = decoded.memberCode
  
    try {
      // Make the API call to change the password
      const response = await axios.put(`${baseUrl}/auth/change-password`, {
        memberCode: memberCode, 
        currentPassword: passwordForm.currentPassword,
        newPassword: passwordForm.newPassword
      });
  
      // Check for successful response
      if (response.status === 200) {
        toast.success('Password changed successfully!');
      } else {
        toast.error('Failed to change the password!');
      }
  
      // Reset form and close modal on success
      setPasswordForm({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      });
      setShowPasswordModal(false);
    } catch (error) {
      // Extract the error message from the response
      const errorMessage = error?.response?.data?.message || 'Error changing password. Please try again!';
  
      // Show the error message
      toast.error(errorMessage);
  
      console.error('Password change error:', error);
    }
  };

  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setProfileForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePasswordChangeInput = (e) => {
    const { name, value } = e.target;
    setPasswordForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const getScrollThreshold = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1440) return 45;
    if (screenWidth >= 768 && screenWidth < 1440) return 30;
    return 15; // 767px and smaller
  };

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > getScrollThreshold());
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  return (
    <>
      <header className={`header ${isSticky ? "sticky" : ""}`}>
        <div className="container">
          <div className="main-nav flex">
            <div className="logo">
              <Link to="/">
                <img src="/images/logo.svg" alt="Logo" />
              </Link>
            </div>
            <button className="hamburger" onClick={toggleMenu}>
              <div className={`line ${isMenuOpen ? "open" : ""}`}></div>
              <div className={`line ${isMenuOpen ? "open" : ""}`}></div>
              <div className={`line ${isMenuOpen ? "open" : ""}`}></div>
            </button>
            <nav className={`${isMenuOpen ? "show" : ""}`}>
              <ul>
                <li>
                  <a href="/token/transactions" style={{ cursor: "pointer" }}>My Transactions</a>
                </li>
                 <li>
                  <a href="/token/staking" style={{ cursor: "pointer" }}>My Staking</a>
                </li>
                <li>
                  <a href="/token/rzto" style={{ cursor: "pointer" }}>My Tokens</a>
                </li>
                <li>
                  <a href="/token/claim-token" style={{ cursor: "pointer" }}>Claim Tokens</a>
                </li>
                {username ? (
                  <li className="profile-container" style={{ position: "relative", marginTop:'10px' }}>
                    <div
                      className="avatar"
                      onClick={toggleDropdown}
                      style={{
                        width: "30px", height: "30px", borderRadius: "50%",
                        backgroundColor: "#f1c40f", color: "#fff",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontWeight: "bold", textTransform: "uppercase",
                        cursor: "pointer", fontSize: "24px"
                      }}
                    >
                      {profileForm.firstName ? profileForm.firstName.charAt(0).toUpperCase() : username.charAt(0).toUpperCase()}
                    </div>
                    {isDropdownOpen && (
                      <div
                        className="dropdown-card"
                        style={{
                          position: "absolute",
                          top: "70px",
                          right: "0",
                          backgroundColor: "white",
                          padding: "20px",
                          borderRadius: "12px",
                          boxShadow: "0 6px 12px rgba(0,0,0,0.15)",
                          width: "270px",
                          textAlign: "left",
                          zIndex: 1000,
                        }}
                      >
                        <p style={{ fontSize: "16px", fontWeight: "500", color: "#333" }}>
                          Welcome <span style={{ fontWeight: "700" }}>
                            {profileForm.firstName} {profileForm.lastName}
                          </span>!
                        </p>

                        {profileForm.email && (
                          <p style={{ marginBottom: "20px", fontSize: "13px", color: "#777" }}>
                            {profileForm.email}
                          </p>
                        )}
                        {profileForm.walletAddress && (
                          <p style={{ 
                            marginBottom: "20px", 
                            fontSize: "13px", 
                            color: "#777",
                            wordBreak: "break-all"  
                          }}>
                            Wallet Address:<br></br> {profileForm.walletAddress}
                          </p>
                        )}

                        <button
                          onClick={handleProfileEdit}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            border: "none",
                            backgroundColor: "#f9f9f9",
                            color: "#333",
                            padding: "10px 12px",
                            borderRadius: "8px",
                            cursor: "pointer",
                            width: "100%",
                            marginBottom: "10px",
                            fontSize: "14px",
                          }}
                        >
                          <EditIcon size={18} />
                          Edit Profile
                        </button>

                        <button
                          onClick={handlePasswordChange}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            border: "none",
                            backgroundColor: "#f9f9f9",
                            color: "#333",
                            padding: "10px 12px",
                            borderRadius: "8px",
                            cursor: "pointer",
                            width: "100%",
                            marginBottom: "10px",
                            fontSize: "14px",
                          }}
                        >
                          <KeyIcon size={18} />
                          Change Password
                        </button>

                        <button
                          onClick={handleLogout}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            border: "none",
                            backgroundColor: "#ff4d4f",
                            color: "#fff",
                            padding: "10px 12px",
                            borderRadius: "8px",
                            cursor: "pointer",
                            width: "100%",
                            fontSize: "14px",
                          }}
                        >
                          <LogoutIcon size={18} />
                          Logout
                        </button>
                      </div>
                    )}
                  </li>
                ) : (
                  <li>
                    <Link to="/token/signin" className="btn btn-white">Buy Token</Link>
                  </li>
                )}
              </ul>
            </nav>
          </div>
        </div>
      </header>

      {/* Profile Edit Modal */}
      {showProfileModal && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "10px",
            width: "90%",
            maxWidth: "500px"
          }}>
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px"
            }}>
              <h3 style={{ margin: 0 }}>Edit Profile</h3>
              <button onClick={() => setShowProfileModal(false)} style={{
                background: "none",
                border: "none",
                fontSize: "20px",
                cursor: "pointer"
              }}>
                ×
              </button>
            </div>
            <form onSubmit={handleProfileSubmit}>
              <div style={{ marginBottom: "15px" }}>
                <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>First Name</label>
                <input
                  type="text"
                  name="firstName"
                  value={profileForm.firstName}
                  onChange={handleProfileChange}
                  required
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ddd"
                  }}
                />
              </div>
              <div style={{ marginBottom: "15px" }}>
                <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  value={profileForm.lastName}
                  onChange={handleProfileChange}
                  required
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ddd"
                  }}
                />
              </div>
              <div style={{ marginBottom: "20px" }}>
                <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Email</label>
                <input
                  type="email"
                  name="email"
                  value={profileForm.email}
                  onChange={handleProfileChange}
                  required
                  readOnly
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ddd"
                  }}
                />
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                <button
                  type="button"
                  onClick={() => setShowProfileModal(false)}
                  style={{
                    padding: "10px 15px",
                    borderRadius: "5px",
                    border: "none",
                    backgroundColor: "#f5f5f5",
                    cursor: "pointer"
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  style={{
                    padding: "10px 15px",
                    borderRadius: "5px",
                    border: "none",
                    backgroundColor: "#f1c40f",
                    color: "white",
                    cursor: "pointer"
                  }}
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Change Password Modal */}
      {showPasswordModal && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "10px",
            width: "90%",
            maxWidth: "500px"
          }}>
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px"
            }}>
              <h3 style={{ margin: 0 }}>Change Password</h3>
              <button onClick={() => setShowPasswordModal(false)} style={{
                background: "none",
                border: "none",
                fontSize: "20px",
                cursor: "pointer"
              }}>
                ×
              </button>
            </div>
            <form onSubmit={handlePasswordSubmit}>
              <div style={{ marginBottom: "15px" }}>
                <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Current Password</label>
                <input
                  type="password"
                  name="currentPassword"
                  value={passwordForm.currentPassword}
                  onChange={handlePasswordChangeInput}
                  required
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ddd"
                  }}
                />
              </div>
              <div style={{ marginBottom: "15px" }}>
                <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>New Password</label>
                <input
                  type="password"
                  name="newPassword"
                  value={passwordForm.newPassword}
                  onChange={handlePasswordChangeInput}
                  required
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ddd"
                  }}
                />
              </div>
              <div style={{ marginBottom: "20px" }}>
                <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Confirm New Password</label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={passwordForm.confirmPassword}
                  onChange={handlePasswordChangeInput}
                  required
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ddd"
                  }}
                />
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                <button
                  type="button"
                  onClick={() => setShowPasswordModal(false)}
                  style={{
                    padding: "10px 15px",
                    borderRadius: "5px",
                    border: "none",
                    backgroundColor: "#f5f5f5",
                    cursor: "pointer"
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  style={{
                    padding: "10px 15px",
                    borderRadius: "5px",
                    border: "none",
                    backgroundColor: "#f1c40f",
                    color: "white",
                    cursor: "pointer"
                  }}
                >
                  Change Password
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;